/*
 * File: chart.ts
 * File Created: 2024-02-23 10:49:52
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:30:55
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { Component, Emit, Prop } from "vue-property-decorator";
import VChart from "vue-echarts";
/// Val warning: this line make build package fail
/// import "echarts";
import { ObjectHelper } from "@root/core";

@Component({
    components: { VChart },
})
export default class Chart extends BaseComponent {
    @Prop({ type: Array, required: false })
    declare value: any[] | undefined;

    @Prop({ type: String, default: undefined })
    theme!: string;

    @Prop({ type: Object, required: true })
    option!: any;

    @Prop({ type: Array, default: undefined })
    links: any[] | undefined;

    @Prop({ type: Boolean, default: false })
    autoresize!: boolean;

    @Prop({ type: Boolean, default: false })
    loading!: boolean;

    /// Events
    @Emit("click")
    doClick(o) {
        return o;
    }

    /// private helper
    get mergedOptions() {
        let opt = ObjectHelper.deepClone(this.option);
        if (opt.series == null) opt.series = [];
        if (opt.series.length === 0) opt.series.push({});
        opt.series[0] = {
            ...opt.series[0],
            ...(this.value ? { data: this.value } : {}),
            ...(this.links ? { links: this.links } : {}),
        };
        return opt;
    }

    observer: any = null;
    chartVisible: boolean = false;
    mounted() {
        this.$nextTick(() => {
            this.observer = new IntersectionObserver((entries) => {
                const interacting = entries.reduce((final, value) => {
                    if (final) return final;
                    if (value.isIntersecting) return true;
                    return final;
                }, false);
                this.chartVisible = interacting;
            });
            this.observer.observe(this.$el);

            (this.$el as any).style.visibility = "hidden";
            this.$nextTick(() => {
                (this.$el as any).style.visibility = "visible";
            });
        });
    }
}
